<template>
  <div>
    <template v-if="manufacturersDiscounts.length === 0">
      <span class="text-primary">
        Brak przypisanych rabatów.
      </span>
    </template>
    <template v-else>
      <d-row
        v-for="(discount, index) of manufacturersDiscounts"
        :key="'manufacturer-discount-item-' + index"
        :class="{
          'my-2 pb-2 mx-0': true,
          'border-bottom': index < (manufacturersDiscounts.length -1)
        }">
        <d-col sm="10" class="pl-0">
          <strong>{{ retiriveManufacturerName(discount.id) }}</strong>
        </d-col>
        <d-col sm="2" class="text-left text-sm-right pr-0 pl-sm-1 pl-0">
          <span class="text-success">
            <strong>{{ discount.discount }} %</strong>
          </span>
        </d-col>
      </d-row>
    </template>
  </div>
</template>

<script>
export default {
  name: 'manufacturer-discount-info',
  props: [
    'manufacturersDiscounts',
    'allManufacturers'
  ],
  methods: {
    retiriveManufacturerName(manufacturerID) {
      if (!this.allManufacturers.length) {
        return '';
      }

      return this.allManufacturers.find(manufacturer => manufacturer.id === manufacturerID).name
    }
  }
}
</script>
